import {AuthGuard} from '../../shared/guards/AuthGuard';
import {SinisterValuesPresentation} from './components';
import {Sidebar} from '../../shared/components';

export const SinisterValuesPage = (): JSX.Element => {
    return (
        <AuthGuard>
            <Sidebar>
                <SinisterValuesPresentation/>
            </Sidebar>
        </AuthGuard>
    )
};